import { SortIcon } from '@unistocks/components/table/sort-icon';
import { Table } from '@unistocks/components/table/table';
import { AssetFilter } from '@unistocks/features/admin/components/asset-management/asset-filter';
import { AdminActions, selectAssetFilter } from '@unistocks/features/admin/store/admin.slice';
import { SortOrder } from '@unistocks/proxy/axios-client';
import { useAppDispatch, useAppSelector } from '@unistocks/shared/hooks/redux-hooks';
import { t } from '@unistocks/shared/localization/index.ts';

export const AssetListHeader: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const dispatch = useAppDispatch();
  const filter = useAppSelector(selectAssetFilter);

  const handleSorting = (prop: AssetFilter['sorting']['prop']) => {
    dispatch(
      AdminActions.setAssetFilter({
        ...filter,
        sorting: {
          prop,
          direction:
            filter.sorting.prop === prop
              ? filter.sorting.direction === SortOrder.Ascending
                ? SortOrder.Descending
                : SortOrder.Ascending
              : SortOrder.Ascending
        }
      })
    );
  };

  return (
    <Table.Head>
      <Table.Row>
        <Table.HeaderCell
          sortable
          cellLocation="first"
          cellWidth={'$16'}
          gap={'$2'}
          disabled={isLoading}
          onPress={() => handleSorting('name')}
        >
          <Table.HeaderCellText>{t('::Name')}</Table.HeaderCellText>
          <SortIcon prop="name" sorting={filter.sorting} isLoading={isLoading} />
        </Table.HeaderCell>
        <Table.HeaderCell
          sortable
          cellLocation="middle"
          gap={'$2'}
          disabled={isLoading}
          onPress={() => handleSorting('type')}
        >
          <Table.HeaderCellText>{t('::Type')}</Table.HeaderCellText>
          <SortIcon prop="type" sorting={filter.sorting} isLoading={isLoading} />
        </Table.HeaderCell>
        <Table.HeaderCell
          sortable
          cellLocation="middle"
          gap={'$2'}
          disabled={isLoading}
          onPress={() => handleSorting('figi')}
        >
          <Table.HeaderCellText>{t('::Assets:OpenFigi')}</Table.HeaderCellText>
          <SortIcon prop="figi" sorting={filter.sorting} isLoading={isLoading} />
        </Table.HeaderCell>
        <Table.HeaderCell
          sortable
          cellLocation="middle"
          alignHeaderCells={{ x: 'end', y: 'center' }}
          gap={'$2'}
          disabled={isLoading}
          onPress={() => handleSorting('currentPrice')}
        >
          <Table.HeaderCellText>{t('::CurrentPrice')}</Table.HeaderCellText>
          <SortIcon prop="currentPrice" sorting={filter.sorting} isLoading={isLoading} />
        </Table.HeaderCell>
        <Table.HeaderCell
          sortable
          cellLocation="last"
          alignHeaderCells={{ x: 'end', y: 'center' }}
          gap={'$2'}
          disabled={isLoading}
          onPress={() => handleSorting('updated')}
        >
          <Table.HeaderCellText>{t('::LastUpdate')}</Table.HeaderCellText>
          <SortIcon prop="updated" sorting={filter.sorting} isLoading={isLoading} />
        </Table.HeaderCell>
      </Table.Row>
    </Table.Head>
  );
};

AssetListHeader.displayName = 'AssetListHeader';
